import { Card } from 'shared/ui/card';
import { EyeIcon } from 'shared/ui/icons';
import { Input } from 'shared/ui/input';
import { Table } from 'shared/ui/table';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import { initialState, dataDummy } from './list-policy-overview.constant';
import { columns } from './list-policy-overview.columns';

const ListPolicyOverview = () => {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [listPatient, setListPatient] = useState([]);
  const navigate = useNavigate();

  const datas = dataDummy.map((dt) => ({
    ...dt,
    status: (
      <div>
        <span
          className={`px-2 py-1 rounded-full text-xs ${dt.status === 'active' ? 'bg-green-100 text-green-800' : dt.status === 'kadaluwarsa' ? 'bg-red-100 text-red-800' : 'bg-[#F2F4F7] text-[#344054]'}`}
        >
          {dt.status}
        </span>
      </div>
    ),
    actions: (
      <div className="flex items-center gap-2 flex-nowrap">
        <span
          className="cursor-pointer"
          onClick={() => navigate(`/policy-overview/${dt.id}`)}
        >
          <EyeIcon color="#6b7280" />
        </span>
      </div>
    ),
  }));

  const handleSearchPatient = () => {
    setListPatient(datas);
  };

  const handleReset = () => {
    setFormData(initialState);
    setListPatient([]);
  };

  const isDisable =
    formData.patient_name === '' &&
    formData.patient_birth_date === '' &&
    formData.patient_nik === '' &&
    formData.patient_policy_number === '';

  return (
    <div className="flex flex-col gap-6">
      <Card className="gap-6">
        <div className="w-full flex flex-col justify-between gap-1">
          <p className={`text-xl font-semibold text-[#101828]`}>
            Informasi Pasien
          </p>
          <p className="text-[#101828] ">
            Silakan mencari mengisi data di bawah untuk mencari data pasien
          </p>
        </div>
        <div className="grid grid-cols-4 gap-4">
          <div className="w-full flex flex-col space-y-2">
            <p className="text-sm font-[500] text-[#344054]">Nama Pasien</p>
            <Input
              type="text"
              value={formData.patient_name}
              className="border-2"
              placeholder="Nama Pasien"
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  patient_name: e.target.value,
                }));
                setErrors((prev) => ({
                  ...prev,
                  patient_name: '',
                }));
              }}
            />
            {/* {errors?.patient_name && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">
                  Nama pasien tidak boleh kosong
                </span>
              </div>
            )} */}
          </div>
          <div className="w-full flex flex-col space-y-2">
            <p className="text-sm font-[500] text-[#344054]">Tanggal Lahir</p>
            <DatePicker
              selected={formData.patient_birth_date}
              dateFormat="dd MMM yyyy"
              data
              maxDate={new Date()} // Prevents selecting future dates
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={100} // Allows selecting old birth years easily
              placeholderText="dd/mm/yyyy"
              className="date-picker-patient border-2 rounded-md px-4 py-2 focus:ring-1 focus:ring-blue-500 focus:outline-none w-full"
              onChange={(date) => {
                const formattedDate = date
                  ? date.toISOString().split('T')[0]
                  : '';
                setFormData((prev) => ({
                  ...prev,
                  patient_birth_date: formattedDate,
                }));
                setErrors((prev) => ({
                  ...prev,
                  patient_birth_date: '',
                }));
              }}
            />

            {/* {errors?.patient_birth_date && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">
                  {Tanggalahir tidak boleh kosong')}
                </span>
              </div>
            )} */}
          </div>
          <div className="w-full flex flex-col space-y-2">
            <p className="text-sm font-[500] text-[#344054]">Nomor KTP</p>
            <Input
              className="border-2"
              type="tel"
              pattern="[0-9]*"
              inputMode="numeric"
              value={formData.patient_nik}
              placeholder="Nomor KTP"
              onChange={(e) => {
                const nik = e.target.value.replace(/\D/g, '');
                setFormData((prev) => ({
                  ...prev,
                  patient_nik: nik,
                }));
                setErrors((prev) => ({
                  ...prev,
                  patient_nik: '',
                }));
              }}
            />
            {/* {errors?.patient_nik && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">
                  Nomor ktp tidak boleh kosong
                </span>
              </div>
            )} */}
          </div>
          <div className="w-full flex flex-col space-y-2">
            <p className="text-sm font-[500] text-[#344054]">Nomor Polis</p>
            <Input
              className="border-2"
              type="tel"
              pattern="[0-9]*"
              inputMode="numeric"
              value={formData.patient_policy_number}
              placeholder="Nomor Polis"
              onChange={(e) => {
                const number = e.target.value.replace(/\D/g, '');
                setFormData((prev) => ({
                  ...prev,
                  patient_policy_number: number,
                }));
                setErrors((prev) => ({
                  ...prev,
                  patient_policy_number: '',
                }));
              }}
            />
            {errors?.patient_policy_number && (
              <div className="w-full justify-start items-start flex">
                <span className="text-red-500 text-sm">
                  Nomor polis tidak boleh kosong
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="w-full flex justify-end text-center gap-2">
          <button
            onClick={handleReset}
            type="button"
            disabled={isDisable}
            className={`flex w-auto bg-White border justify-center rounded-md px-3 py-2 text-medium font-semibold leading-6 text-slate-700 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${isDisable ? 'opacity-50' : ''}`}
          >
            Reset
          </button>
          <button
            onClick={handleSearchPatient}
            type="button"
            disabled={isDisable}
            className={`flex w-auto justify-center rounded-md bg-blue-500 px-3 py-2 text-sm leading-6 text-white shadow-sm ${isDisable ? 'opacity-50' : ''}`}
          >
            Cari Pasien
          </button>
        </div>
      </Card>
      <Card className="w-full pt-6">
        <Table
          className="w-full"
          data={listPatient}
          columns={columns}
          customEmpty={
            <div className="flex flex-col gap-2">
              <p className="text-sm text-[#344054] font-medium">
                Tidak Ada List Pasien
              </p>
              <p className="text-xs text-[#667085]">
                Silakan isi informasi pasien untuk mencari data
              </p>
            </div>
          }
          pageSize={5}
          // loading={isFetching}
          page={datas?.meta?.page || 1}
          total={datas?.meta?.total || 5}
          limit={datas?.meta?.limit || 5}
          // handlePageSizeChange={handlePageSizeChange}
          // handlePaginationChange={handlePaginationChange}
          // handleSortOrderChange={handleSortOrderChange}
        />
      </Card>
    </div>
  );
};

export default ListPolicyOverview;
